import NavMenu from "./NavMenu/NavMenu";
import Logo from "../../UI/Logo/Logo";
import { LOGO_THEME } from "../../../constants/logo";
const Footer = () => {
  return (
    <footer className="py-10 px-12 bg-dark-blue flex justify-between items-center">
      <div className="flex flex-col">
        <Logo theme={LOGO_THEME.WHITE} />
        <p dir="ltr" className="text-white text-xl font-semibold gap-1">
          &copy; Copyright All rights Reserved.
        </p>
      </div>
      <nav>
        <NavMenu />
      </nav>
    </footer>
  );
};

export default Footer;
